export default __webpack_public_path__ + "static/media/mobileapp.b956cfff.png";